import { createContext, useContext } from 'react'
import type { NextRouter } from 'next/router'

const AppRouterContext = createContext<NextRouter | null>(null)

export function AppRouterProvider({
  router,
  children,
}: {
  router: NextRouter
  children: React.ReactNode
}) {
  return <AppRouterContext.Provider value={router}>{children}</AppRouterContext.Provider>
}

/** Prefer over useRouter() — works during static prerender when router is passed via _app. */
export function useAppRouter(): NextRouter {
  const router = useContext(AppRouterContext)
  if (!router) {
    throw new Error('useAppRouter requires AppRouterProvider')
  }
  return router
}
